
import { MediaMatcher } from '@angular/cdk/layout';
import { Router } from '@angular/router';
import {
  ChangeDetectorRef,
  Component,
  OnDestroy


} from '@angular/core';
import { MenuItems } from '../../shared/menu-items/menu-items';
import { IdleTimeoutService } from '../../auth/services/idle-timeout.service';



/** @title Responsive sidenav */
@Component({
  selector: 'app-full-layout',
  templateUrl: 'full.component.html',
  styleUrls: []
})
export class FullComponent implements OnDestroy {
  mobileQuery: MediaQueryList;
  dir: 'ltr' | 'rtl' = 'ltr';
  green = false;
  blue = false;
  dark = false;
  minisidebar = false;
  boxed = false;
  danger = false;
  showHide = false;
  horizontal = false;
  url = '';
  sidebarOpened = false;
  status = false;

  public showSearch = false;

  public config: any = {};
  private _mobileQueryListener: () => void;

  private readonly SETTINGS_STORAGE_KEY = 'bsfms.layoutSettings';

  /**
   * Whether the horizontal top-nav layout is actually in force.
   *
   * The user preference (`horizontal`) is honoured only from the
   * sidenav breakpoint up. Below it the top-nav has nowhere to go but
   * a full-height vertical stack pushed above the page content, and
   * the drawer — the layout that IS designed for narrow screens — is
   * hidden. So on tablet/phone widths we fall back to the vertical
   * drawer layout while leaving the stored preference untouched, and
   * it re-applies as soon as there is room for it again.
   */
  get horizontalActive(): boolean {
    return this.horizontal && this.mobileQuery.matches;
  }

  clickEvent() {
    this.status = !this.status;
  }

  toggleHorizontal(checked: boolean): void {
    this.horizontal = checked;
    if (checked) {
      this.minisidebar = false;
    }
    this.persistSettings();
  }

  toggleRtl(checked: boolean): void {
    this.dir = checked ? 'rtl' : 'ltr';
    this.persistSettings();
  }

  toggleBoxed(checked: boolean): void {
    this.boxed = checked;
    this.persistSettings();
  }

  toggleMinisidebar(checked: boolean): void {
    this.minisidebar = checked;
    if (checked) {
      this.horizontal = false;
    }
    this.persistSettings();
  }

  private persistSettings(): void {
    try {
      const settings = {
        horizontal: this.horizontal,
        dir: this.dir,
        boxed: this.boxed,
        minisidebar: this.minisidebar
      };
      localStorage.setItem(this.SETTINGS_STORAGE_KEY, JSON.stringify(settings));
    } catch {
      // localStorage unavailable (private mode / quota) — silently skip
    }
  }

  private restoreSettings(): void {
    try {
      const raw = localStorage.getItem(this.SETTINGS_STORAGE_KEY);
      if (!raw) { return; }
      const s = JSON.parse(raw);
      if (typeof s.horizontal === 'boolean') { this.horizontal = s.horizontal; }
      if (s.dir === 'rtl' || s.dir === 'ltr') { this.dir = s.dir; }
      if (typeof s.boxed === 'boolean') { this.boxed = s.boxed; }
      if (typeof s.minisidebar === 'boolean') { this.minisidebar = s.minisidebar; }
    } catch {
      // corrupt JSON — ignore and fall back to defaults
    }
  }


  constructor(
    public router: Router,
    changeDetectorRef: ChangeDetectorRef,
    media: MediaMatcher,
    public menuItems: MenuItems,
    private idleTimeoutService: IdleTimeoutService
  ) {
    // 1024px, not 1023px: sidebar.scss reserves the 240px content margin
    // from `min-width: 1024px`, so a 1023px query left a one-pixel window
    // where the drawer was docked but the content had no margin and the
    // two overlapped. Keep this in sync with $bp-sidenav-side.
    this.mobileQuery = media.matchMedia('(min-width: 1024px)');
    this._mobileQueryListener = () => changeDetectorRef.detectChanges();
    // tslint:disable-next-line: deprecation
    this.mobileQuery.addListener(this._mobileQueryListener);
    this.restoreSettings();
    // Start session idle timeout tracking (30 min)
    this.idleTimeoutService.start();
  }

  ngOnDestroy(): void {
    // tslint:disable-next-line: deprecation
    this.mobileQuery.removeListener(this._mobileQueryListener);
    this.idleTimeoutService.stop();
  }


  // Mini sidebar
}
